import {
  store,
  addComboToOrder,
  addOrderForEditDetails,
  addOrderItems,
  deleteAllOrderItems,
  setOrderTableNumber,
  changeDeliveryType
} from "@redux"

const moveOfflineOrderToCartForEdit = (offlineOrder) => {
  store.dispatch(
    deleteAllOrderItems()
  )

  offlineOrder.order.combos.forEach(combo =>
    store.dispatch(
      addComboToOrder(combo)
    )
  )

  store.dispatch(
    addOrderItems(offlineOrder.order.items)
  )

  store.dispatch(
    changeDeliveryType(
      offlineOrder.deliveryType
    )
  )

  store.dispatch(
    setOrderTableNumber(
      offlineOrder.order.tableNumber
    )
  )

  const couponCodes = []
  offlineOrder.discounts.forEach(d =>
    couponCodes.push(d.couponCode)
  )

  store.dispatch(
    addOrderForEditDetails({
      note: offlineOrder.note,
      date: offlineOrder.order.date,
      tableNumber: offlineOrder.order.tableNumber,
      offlineOrderId: offlineOrder.offlineOrderId,
      orderCode: offlineOrder.code,
      items: [...offlineOrder.order.items],
      combos: [...offlineOrder.order.combos],
      subPaymentItems: {},
      couponCodes,
      discounts: [],
      isOffline: true,
      deliveryService: offlineOrder.deliveryService,
      deliveryType: offlineOrder.deliveryType
    })
  )
}

export default moveOfflineOrderToCartForEdit